import * as React from 'react';

import { createErrorFunction } from '../utils/TypescriptHelpers';
import { ApiRequests } from './ApiRequests';

export const defaultApiRequests: ApiRequests = {
  sendImpactAnalysisEmailAndShowToast:
    createErrorFunction('Function of default ApiRequests context called: sendImpactAnalysisEmailAndShowToast'),
  setColumnDescription:
    createErrorFunction('Function of default ApiRequests context called: setColumnDescription'),
  setFieldDescription:
    createErrorFunction('Function of default ApiRequests context called: setFieldDescription'),
  setDrillPathFieldDescription:
    createErrorFunction('Function of default ApiRequests context called: setDrillPathFieldDescription'),
  canUserSetColumnDescription:
    createErrorFunction('Function of default ApiRequests context called: canUserSetColumnDescription'),
  canUserSetFieldDescription:
    createErrorFunction('Function of default ApiRequests context called: canUserSetFieldDescription'),
  canUserSetColumnTags:
    createErrorFunction('Function of default ApiRequests context called: canUserSetColumnTags'),
  canUserSendImpactAnalysisEmail:
    createErrorFunction('Function of default ApiRequests context called: canUserSendImpactAnalysisEmail'),
  getAllowedClasses:
    createErrorFunction('Function of default ApiRequests context called: getAllowedClasses'),
  isSiteCreatorOrHigher:
    createErrorFunction('Function of default ApiRequests context called: isSiteCreatorOrHigher'),
  searchMatchingTags:
    createErrorFunction('Function of default ApiRequests context called: searchMatchingTags'),
  updateColumnTags:
    createErrorFunction('Function of default ApiRequests context called: updateColumnTags'),
  getContainerForContent:
    createErrorFunction('Function of default ApiRequests context called: getContainerForContent'),
};

export const ApiRequestsContext = React.createContext<ApiRequests>(defaultApiRequests);
